import React from 'react';

import NextImage from '../common/NextImage';

const GolfScoreTable = ({ data }) => {
  const baseURL =
    process.env.REACT_APP_BASE_URL ??
    "https://ipublisher-microservices.6lgx.com";

  return (
    <div className="global_table golf_score_table">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>P</th>
            <th>THRU</th>
            <th>Today</th>
            <th>R1</th>
            <th>R2</th>
            <th>R3</th>
            <th>R4</th>
            <th>STROKES</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className="player_name_wrp">
                <div className="flag_img">
                  <NextImage src={`${baseURL}/public/assets/images/flags/country_${data?.fid}.png`} width={32} height={32} />
                </div>
                <span className="cr_name">{data?.nm}</span>
              </div>
            </td>
            <td>
              <strong>{data?.score?.par}</strong>
            </td>
            <td>{data?.teet || '-'}</td>
            <td>{data?.score?.tdy || '-'}</td>
            <td>{data?.score?.r1 || '-'}</td>
            <td>{data?.score?.r2 || '-'}</td>
            <td>{data?.score?.r3 || '-'}</td>
            <td>{data?.score?.r4 || '-'}</td>
            <td>{data?.score?.tot || '-'}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default GolfScoreTable;
